module.exports = __webpack_public_path__ + "static/media/youtube-icon.7da5bbdd.svg";